module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAcCAYAAACgXdXMAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAK8AAACvABQqw0mAAAABZ0RVh0Q3JlYXRpb24gVGltZQAwOC8xMi8xMKNAeX0AAAAYdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3Jrc0+zH04AAABNSURBVAiZbYwxDkBAAATHOuEJag/QeZKf+olGpyd2dZJLdJuZyTKuW7TME7JB1210P0ZxkBOUBNnfSmrrH/bXVS+lbdDQF9S1Qvtx8gJrGEZ38VpMAgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client/l_middle.png
// module id = 708
// module chunks = 110